/**
 * wql
 * @description 培训路径管理页面配置
 * @Date 2020/8/13
 */
import React from 'react'
import { component_tool, framework_tool } from '../../../../tool';
import { WizTableForm } from '../../../common'
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
import HighSet from "@/containers/common/highSet";

let { WizModal } = component_tool;

//配置项
let componentName = 'trainPath'
const columns = [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: "名称",
    name: "name",
    searchItem: {},
    tableItem: {
      // width: 300
    },
  },
  {
    title: "品牌",
    name: "orgIdList",
    searchItem: {
      diy: WizTableForm,
      selectType:"radio",
      ...organizationConfig
    }
  },
  {
    title: "岗位",
    name: "positionIdList",
    searchItem: {
      diy: WizTableForm,
      ...positionConfig,
    }
  },

  // {
  //   title: "必修范围",
  //   name: "requiredTargetScopeName",
  //   tableItem: {
  //     width: 450
  //   },
  // },

  // {
  //   title: "选修范围",
  //   name: "electiveTargetScopeName",
  //   tableItem: {width: 450},
  // },
  {
    title: "阶段数量",
    name: "validStageCount",
    tableItem: {width: 100},
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    dict: [
      { code: 1, codeName: '草稿' },
      { code: 2, codeName: '已发布' },
      { code: 3, codeName: '已关闭' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {
    },
  },

];

const templateConfig = (data) => {
  let {pathname} = data
  return {
    mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        // cols: {
        //   xs: 12,
        //   md: 12,
        //   xl: 12
        // },
        buttonSort:['add','exportPathInfo','exportPathContent','import'],
        buttons: [
          {
            key: 'add',
            custom: true,
            params: { icon: 'plus', children: '新增', type: 'primary' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: pathname + '/trainPathAdd'
              }
            }
          },
          {
            key: 'delete',
            custom: true,
            params: { icon: 'delete', children: '删除', type: 'danger',},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "del",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (rows.length < 1){
                  wizNotice.warn("请选择一条路径！");
                  return null
                }
                let ids = [];
                for (let i = 0;i< rows.length;i++){
                  ids.push(rows[i].id)
                }
                const content = `删除后数据不可恢复，您确定要删除选中的路径吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      ids: ids
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: 'exportPathInfo',
            custom: true,
            params: { icon: 'export', children: '导出路径信息', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "exportTrainPathInfo",
                apiParams: {}
              },
              formatParams:(rows,record,filters,callback)=>{
                return {...filters}
              }
            }
          },
          {
            key: 'exportPathContent',
            custom: true,
            params: { icon: 'export', children: '导出路径内容', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "getPathContent",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (rows.length != 1){
                  return {...filters}
                }
                callback && callback({
                  idList: rows[0].id
                })

              }
            }
          },
          {
            key: "import",
            custom: true,
            params: { children: "导入"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname + "/trainPathFileImport"
              }
            }
          },
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
        rowOperateSort:['look','update','releaseOrClose','stageManagement', 'advancedSet'],
      rowOperateView: [
        {
          key: "look",
          custom: true,
          params: { children: "查看"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: pathname + "/lookTrainPath"
            }
          }
        },
        {
          key: "update",
          custom: true,
          params: { children: "编辑" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: pathname + "/trainPathUpd"
            }
          }
        },
        {
          key: "releaseOrClose",
          custom: true,
          params: { children: "发布"},
          textFormat: {
            recordKey: 'state',
            dirt: { 1: '发布', 2: '关闭', 3: "发布"}
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "updateState",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['state'] === 2 ? "关闭" : "发布"
              }该路径吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record['state'] === 2 ? 3 : 2,
                    ids: [record['id']]
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: "stageManagement",
          custom: true,
          params: { children: "阶段管理"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: pathname + "/trainPathStage"
            }
          }
        },
        {
          key: 'advancedSet',
          custom: true,
          params: {children: '高级设置'},
          customOnClick: {
            key: 'modal',
            params: {
              modalParams: {
                title: '高级设置',
                bordered: true,
                footer: null,
                destroyOnClose: true,
                diy: (e) => {
                  return <>
                    <HighSet data={{record: e.record,bizType: 12}} //培训路径，推荐范围选 必修路径
                             changeModal={e.changeModal}
                    />
                  </>
                },
                width: 950
              },
            }
          },
          // recordChangeParams: ({record, rows}) => {
          //   let disabled = false
          //   if (record && record['state'] !== 2) {
          //     disabled = true
          //   }
          //   return {disabled}
          // }
        },
      ],
      showAuth : [
        {
          title: "选修范围",
          dataIndex: "electiveTargetScope",
          width: 150
        },
        {
          title: "必修范围",
          dataIndex: "requiredTargetScope",
          width: 150
        },
      ]
    }
  }
  }
};

const apis = {
  list: {
    path: `${componentName}/pageList`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  updateState:{
    path: `${componentName}/updateState`,
    payload: {
      key: `${componentName}@updateState`,
      apiParams: {}
    }
  },
  del:{
    path: `${componentName}/del`,
    payload: {
      key: `${componentName}@del`,
      apiParams: {}
    }
  },
  exportTrainPathInfo: {
    path: `${componentName}/exportTrainPathInfo`,
    payload: {
      key: `${componentName}@exportTrainPathInfo`,
      apiParams: {}
    }
  },
  getPathContent: {
    path: `${componentName}/getPathContent`,
    payload: {
      key: `${componentName}@getPathContent`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
